<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    class="close"
                    (click)="closeDialog()"
                    title="Close">
                    <i class="nlrp-icon nlrp-icon-close"></i>
                </button>
                <h3 class="modal-title">{{title}}</h3>
            </div>

            <div class="modal-body">
                <div class="container-fluid well">
                    <div class="row">
                        <div class="col-xs-12">
                            <label class="control-label">Your lodgement has been successfully received by Landgate.</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12">
                            <label class="control-label">
                                A confirmation email of your plan submission will be sent to {{getModel().lodgementEmailAddress}}
                            </label>
                        </div>
                    </div>

                    <br />

                    <div class="row">
                        <div class="col-xs-1">
                            <i class="nlrp-icon nlrp-icon-lodgement-success confirmation-icon nlrp-36 active"></i>
                        </div>
                        <div class="col-xs-11"><h5>Lodge details</h5></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-1"></div>
                        <div class="col-xs-3">
                            <label class="control-label">Plan type</label>
                        </div>
                        <div class="col-xs-8">
                            <label class="control-label">{{getModel().planType.name}}</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-1"></div>
                        <div class="col-xs-3">
                            <label class="control-label">Lodge type</label>
                        </div>
                        <div class="col-xs-8">
                            <label class="control-label">{{getModel().lodgementType.value}}</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-1"></div>
                        <div class="col-xs-3">
                            <label class="control-label">Number</label>
                        </div>
                        <div class="col-xs-8">
                            <label class="control-label">{{getModel().planNumber}}</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-1"></div>
                        <div class="col-xs-3">
                            <label class="control-label">Lodged by</label>
                        </div>
                        <div class="col-xs-8">
                            <label class="control-label">
                                {{getModel().firm ? getModel().firm.firmName : getModel().surveyor.givenNames + " " + getModel().surveyor.familyName}}
                            </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-1"></div>
                        <div class="col-xs-3">
                            <label class="control-label">Date</label>
                        </div>
                        <div class="col-xs-8">
                            <label class="control-label">{{getModel().lodgementDateString}}</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-1"></div>
                        <div class="col-xs-3">
                            <label class="control-label">Reference</label>
                        </div>
                        <div class="col-xs-8">
                            <label class="control-label">{{getModel().customerReference}}</label>
                        </div>
                    </div>

                    <br />

                    <div class="row">
                        <div class="col-xs-1">
                            <i class="nlrp-icon nlrp-icon-paper-clip nlrp-36 confirmation-icon active"></i>
                        </div>
                        <div class="col-xs-11">
                            <h5>Attachment/s received</h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-1"></div>
                        <div class="col-xs-11">
                            @for (attachment of getModel().attachments; track attachment) {
                                <div>
                                    <span>{{attachment.fileName}}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    data-dismiss="modal"
                    (click)="closeDialog()">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>
